module.exports = __webpack_public_path__ + "img/testing.8f27725b.png";